<template>
  <div class="adminConfig">
    <div class="container" >
    <DialogBox ref="resultDialog"></DialogBox>
    <DialogBox ref="confirmationDialog"></DialogBox>
    <LogInDialogBox ref="LogInDialog"></LogInDialogBox>

    <!-- Cambiar contraseña -->
    <v-card class="AdminCard">
      <v-card-subtitle>
        <h3>Cambiar contraseña:</h3> 
      </v-card-subtitle>

      <v-card-subtitle>
        <v-text-field
          v-model="newPassword"
          filled
          label="Nueva contraseña"
          type="password"
        />
        <v-text-field
          v-model="newPasswordRe"
          filled
          label="Repita la contraseña"
          type="password"
        />

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="SubmibButton toolbar-button" color="" text @click="updatePasswordConfirmation">
            Cambiar contraseña <v-icon class="ButtonIcon">mdi-key</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card-subtitle>
    </v-card>

    <!-- Añadir administrador -->
    <v-card class="AdminCard" v-if="userRegister.isAdmin" >
      <v-card-subtitle>
        <h3>Añadir un usuario:</h3> 
      </v-card-subtitle>

      <v-card-subtitle>
        <v-text-field
            v-model="newUserName"
            filled
            label="Nombre"
            type="text"
        />
        <v-text-field
          v-model="newUserMail"
          filled
          label="Correo electrónico"
          type="text"
        />
        <v-text-field
          v-model="newUserPassword"
          filled
          label="Contraseña"
          type="password"
        />
        <v-switch v-model="newUserIsAdmin" class="mx-2" label="Permisos de administrador"></v-switch>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="SubmibButton toolbar-button" color="" text @click="createUserConfirmation">
            Añadir usuario <v-icon class="ButtonIcon">mdi-account-plus</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card-subtitle>
    </v-card>


    <!-- Lista de usuarios dados de alta -->
    <v-toolbar v-if="userRegister.isAdmin" class="toolbars" dark>
      <v-toolbar-title >Usuarios</v-toolbar-title>
    </v-toolbar>
    <v-data-table
            v-if="userRegister.isAdmin"
            :headers="headers"
            :items="usersList"
            sort-desc
            class="elevation-1"
            locale='es'
            :footer-props="{
              'items-per-page-text': 'Filas por página',
              'sort-by-text' : 'Ordenar por'
            }"
            :loading="loading"
            loading-text="Cargando usuarios..."
    >
    <template v-slot:item.isAdmin="{ item }">
      <p v-if="item.isAdmin"> Si </p>
      <p v-if="!item.isAdmin"> No </p>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
              large
              @click="deleteUserConfirmation(item)"
              class="fa fa-trash " aria-hidden="true"
      >
      </v-icon>
    </template>
  </v-data-table>

  </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
// @ is an alias to /src
import { Auth } from '../firebase/auth';
import { DB } from '../firebase/db';
import DialogBox from '../components/DialogBox'
import LogInDialogBox from '../components/LogInDialogBox'
var axios = require('axios');

export default {
  name: 'adminConfig',
  async created() {
    this.$emit('updateTitle', 'Configuracion');
    window.bus.$emit('menu/activarMenu');

    this.user = await Auth.getCurrentUser();
    let self = this;
    
    DB.collection('users').doc(this.user.uid).get()
    .then(function(doc) {
      if(doc.exists) {
        self.userRegister = doc.data();

        if (self.userRegister.isAdmin) {
          self.getUsersList();
          self.loading = false;
        }

      } else {
        self.$refs.resultDialog.show('error', 'El usuario no esta bien registrado en bd.', false);
      }

    }).catch(function(error) {
      console.log("Error loading user config.", error)
    });

    // nos suscribimos
    
  },
  data: () => ({
      loading: true,
      user: null,
      userRegister: {
        isAdmin: false
        },

      newPassword: "",
      newPasswordRe: "",

      newUserName: "",
      newUserMail: "",
      newUserPassword: "",
      newUserIsAdmin: false,

      usersList: [],
      usersListUnsubscribe: undefined,
      deletedUser: undefined,
      headers: [
        { text: 'Usuario', value: 'name', sortable: false },
        { text: 'Correo', value: 'mail', sortable: false },
        { text: 'Permisos administración', value: 'isAdmin', sortable: false},
        { text: 'Acciones', value: 'action', sortable: false },
      ],
      dialog: false,
    }),
    methods: {
      clearFields() {
        this.newUserName = "";
        this.newUserMail = "";
        this.newUserIsAdmin = false;
        this.newUserPassword = "";
        this.newPassword = "";
        this.newPasswordRe = "";
      },
      createUserConfirmation() {

        this.$refs.confirmationDialog.show('question', 
        `El usuario se añadirá`,
        true,
        this.createUser);
      },

      async createUser() {
        var self = this;
        var rd = this.$refs.resultDialog;

        if (this.newUserMail != "" && this.newUserPassword != "" && this.newUserName != "") {
        //   Auth.createUserWithEmailAndPassword(this.newUserMail, this.newUserPassword)
        //   .then(function(result) {
        //     console.log("User created", result.user, result.user.uid)
        //     let user = {
        //       name: self.newUserName,
        //       mail: self.newUserMail,
        //       isAdmin: self.newUserIsAdmin,
        //     };
        //     DB.collection('users').doc(result.user.uid).set(user)
        //     .then( function() {
        //       rd.show('info', 'Usuario creado con exito.', false);
        //       self.clearFields();
        //     })
        //     .catch(function(error) {
        //       rd.show('error', 'Error añadiendo el usuario a la db.', false);
        //       console.error("Error adding document: ", error);
        //     });

        //   })
        //   .catch(function(error) {
        //     // Handle Errors here.
        //     var errorCode = error.code;
        //     var errorMessage = error.message;
        //     console.log("Error creando usuario: ", errorCode, errorMessage)
        //     rd.show('error', errorMessage, false);
        //     self.clearFields();
        //   });
            const token = await this.user.getIdToken();
            const config = {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            }

            const userData = {
                email: this.newUserMail,
                name: this.newUserName,
                password: this.newUserPassword,
                isAdmin: this.newUserIsAdmin
            }

            const response = await axios.default.post('https://us-central1-buzon-ayuntamiento.cloudfunctions.net/users/', userData, config)
            if(response.status == 201) {
                rd.show('info', 'Usuario creado con exito.', false);
                self.clearFields();
            }
            else {
                rd.show('error', 'Error al crear nuevo usuario.', false);
                console.error("Error adding document: ", response.status + ' ' + response.statusText);
            }
        }
        else {
            rd.show('warning', 'Debe rellenar los campos primero.', false);
        }
      },

      updatePasswordConfirmation() {
        this.$refs.confirmationDialog.show('question', 
        `¿Está seguro de que desea cambiar la contraseña?`,
        true,
        this.reLogInPetition);
      },
      reLogInPetition() {
        this.$refs.LogInDialog.show(
          this.updatePassword
        );
      },
      updatePassword(credential) {
        console.log("CREDENCIAL2: ", credential);

        var self = this;
        var rd = this.$refs.resultDialog;

        self.user.reauthenticateWithCredential(credential).then(function() {
          
          if (self.newPassword==self.newPasswordRe && self.newPassword != "") {

            self.user.updatePassword(self.newPassword).then(function() {
              rd.show('info', 'Contraseña cambiada con exito.', false);
              self.clearFields();
            }).catch(function(error) {
              console.log("Error updating password: ", error, error.message);
              rd.show('error', error.message, false);
              self.clearFields();
            });

          } else {
              rd.show('warning', 'Las contraseñas deben coincidir.', false);
          }

        }).catch(function(error) {
          // An error happened.
          rd.show('warning', 'Contraseña incorrecta.', false);
          console.log("ERROR", error)
        });
      },
      getUsersList() {
        if(this.usersListUnsubscribe != undefined) {
          this.usersListUnsubscribe();
        }
        this.usersList = [];

        this.usersListUnsubscribe = DB.collection('users')
        .onSnapshot( snapshots => {
          snapshots.docChanges().forEach( change => {
            let userDoc = change.doc;
            let userData = userDoc.data();
            userData.uid = userDoc.id;
            
            switch (change.type) {
              case "added":
                this.usersList.push(userData);
                break;

              case "modified":
                for (let i = 0; i < this.usersList.length; i++) {
                  if(this.usersList[i].uid == userData.uid)
                  {
                    this.usersList[i] = { ...userData }
                    break;
                  }
                }
                break;

              case "removed":
                for (let i = 0; i < this.usersList.length; i++) {
                  if(this.usersList[i].uid == userData.uid)
                  {
                    this.usersList.splice(i, 1);
                    break;
                  }
                }
                break;
            }
          })

        })

      },
      deleteUserConfirmation(element) {
        this.deletedUser = element;
        this.$refs.confirmationDialog.show('warning', 
        `¿Está seguro que desea eliminar el usuario '${this.deletedUser.name}'?`,
        true,
        this.deleteUserPetition)
      },
      deleteUserPetition () {
        var rd = this.$refs.resultDialog;

        return new Promise(async (resolve, reject) => {
          const token = await this.user.getIdToken();
          const config = {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            }

          axios.delete('https://us-central1-buzon-ayuntamiento.cloudfunctions.net/users/'+this.deletedUser.uid, config)
            .then(function (response) {
              if (response.status == 200) {
                rd.show('info', 'El usuario se ha eliminado correctamente.', false);
                resolve(true);
              } else {
                rd.show('error', 'Ha habido un problema al eliminar el usuario.', false);
                reject(false);
              }
            })
            .catch(function (error) {
              console.log(error);
              reject(error);
            });
        })
      },
    },
    components: {
      DialogBox,
      LogInDialogBox
    },

    computed: {
    },

    watch: {
    },

}
</script>

<style >

.ButtonIcon {
  margin-left: 10px;
}

.AdminCard {
  margin: 1em;
}

</style>